import * as bootbox from "bootbox";
import "bootstrap";
import "jquery-validation";
import "velocity-animate";

let currentTarget: JQuery<HTMLElement> = null;
let currentSelectedLinkId = 0;
let maxSliderLinkIndex = 0;
let enableMouseWheel = true;

$(() => {
    initializeSliderLinks();
    initializeSliderContents();
    currentTarget = $("#top");

    $(".slider-links a").click((event) => {
        $(".slider-links").find("li").removeClass("active");
        $(event.currentTarget).parent().addClass("active");
    });

    $("a.my-fade").click((event) => {
        const selectedLinkId = parseInt($(event.currentTarget).data("index"), 10);
        if (selectedLinkId === currentSelectedLinkId) {
            enableMouseWheel = true;
            return;
        }

        initializeSliderContents();

        const target = (event.currentTarget as HTMLAnchorElement).hash;
        $(target).css("opacity", 0);
        const zIndex = parseInt(currentTarget.css("z-index"), 10) || 0;
        $(target).css("z-index", zIndex + 1);
        $(target).velocity({opacity: 1}, {duration: 800, complete: () => enableMouseWheel = true});

        currentTarget = $(event.currentTarget);
        currentSelectedLinkId = 0;
    });

    $("a.slider").click((event) => {
        const target = (event.currentTarget as HTMLAnchorElement).hash;
        const selectedLinkId = parseInt($(event.currentTarget).data("index"), 10);

        if (selectedLinkId === currentSelectedLinkId) {
            enableMouseWheel = true;
            return;
        }

        if (selectedLinkId > currentSelectedLinkId) {
            scrollForward(target);
        } else {
            scrollBack(target);
        }

        currentSelectedLinkId = selectedLinkId;
    });

    $("a.top-link").click((event) => {
        const target = $(event.currentTarget).attr("xlink:href");
        $(`a[href='${target}']`).click();
    });

    const mousewheelEvent = "onwheel" in document ? "wheel"
        : "onmousewheel" in document ? "mousewheel"
        : "DOMMouseScroll";
    $(document).on(mousewheelEvent, (e: any) => { // TODO
        if (!enableMouseWheel) {
            return;
        }

        enableMouseWheel = false;

        e.preventDefault();

        const delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY)
            : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta
            : -(e.originalEvent.detail);

        let selectedLinkId = currentSelectedLinkId;

        if (delta < 0 && selectedLinkId < maxSliderLinkIndex) {
            selectedLinkId++;
        } else if (delta >= 0 && selectedLinkId > 0)  {
            selectedLinkId--;
        }

        $(".slider-links").find("a")[selectedLinkId].click();
    });

    $("#privacyPolicyModal").on("show.bs.modal", () => {enableMouseWheel = false; }); // 中かっこがないと挙動が変わるため注意
    $("#privacyPolicyModal").on("hide.bs.modal", () => {enableMouseWheel = true; });

    $("#sendMailButton").click(() => {
        // TODO csrf

        $("#contactForm").validate({
            rules: {
                name: {
                    required: true,
                },
                email: {
                    required: true,
                    email: true,
                },
                content: {
                    required: true,
                },
            },
            messages: {
                name: {
                    required: "お名前を入力してください。",
                },
                email: {
                    required: "eメールを入力してください。",
                    email: "eメールが不正です。",
                },
                content: {
                    required: "お問い合わせ内容を入力してください。",
                },
            },
        });

        if (!$("#contactForm").valid()) {
            return;
        }

        $.ajax({
            url: "./contact",
            method: "POST",
            data: $("#contactForm").serialize(),
        }).done(() => {
            $("input").val("");
            $("textarea").val("");
            bootbox.alert("お問い合わせありがとうございました。<br/>(フリーメールをご利用の場合、迷惑メールに振り分けられている場合がありますのでご注意ください。)");
        }).fail(() => {
            bootbox.alert("メールの送信に失敗しました。");
        });
    });
});

function initializeSliderLinks() {
    $(".slider-links").find("a").each((index, elem) => {
        $(elem).data("index", index);
        maxSliderLinkIndex = index;
    });
}

function initializeSliderContents() {
    $(".slider-content-wrapper").each((index: number, elem: HTMLElement) => {
        $(elem).hide();
        $(elem).css("background", "url(" + $(elem).data("img") + ") no-repeat center center");
        $(elem).find(".slider-content").css("background", $(elem).data("mask"));
        $(".fade-in").css("opacity", 0);
    });
}

function scrollForward(target: string) {
    const beforeTarget = currentTarget;
    currentTarget = $(target);
    $(target).height(0);
    $(target).find(".slider-content").velocity({translateY: "+=100vh"}, {duration: 0});
    const zIndex = parseInt(beforeTarget.css("z-index"), 10) || 0;
    $(target).css("z-index", zIndex + 1);
    $(target).show();
    $(target).find(".slider-content").velocity({translateY: 0}, {duration: 800, delay: 200, easing: "ease"});
    $(target).velocity({height: "100%"}, {duration: 800, easing: "ease", complete: () => {
        $(target).find(".fade-in").velocity({opacity: 1}, {duration: 800, complete: () => {
            beforeTarget.find(".fade-in").css("opacity", 0);
            enableMouseWheel = true;
        }});
    }});
}

function scrollBack(target: string) {
    const beforeTarget = currentTarget;
    currentTarget = $(target);
    $(target).height(0); // IEとEdgeのちらつき対策
    $(target).velocity({translateY: "+=100vh"}, {duration: 0});
    $(target).find(".slider-content").height(0);
    const zIndex = parseInt(beforeTarget.css("z-index"), 10) || 0;
    $(target).css("z-index", zIndex + 1);
    $(target).show();
    $(target).find(".slider-content").velocity({height: "100%"}, {duration: 800, delay: 200, easing: "ease"});
    $(target)
        .velocity({height: "100%"}, {duration: 0}) // IEとEdgeのちらつき対策
        .velocity({translateY: 0}, {duration: 800, easing: "ease", complete: () => {
            $(target).find(".fade-in").velocity({opacity: 1}, {duration: 800, complete: () => {
                beforeTarget.find(".fade-in").css("opacity", 0);
                enableMouseWheel = true;
            }});
        }});
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/main/ts/entry-index.ts